import { addSeconds } from 'date-fns/esm';

const getAuthorizationFromToken = (token) => `Bearer ${token}`;

/**
 * Adds an `expiration_date` as an ISO string
 *
 * @param {Object} auth
 */
const transformAuth = (auth) => ({
    ...auth,
    expiration_date: addSeconds(new Date(), auth.expires_in).toISOString(),
});

export { getAuthorizationFromToken, transformAuth };
